import React from 'react';

const BtnModal = ({ accept, text, type,styles }) => {
  return (
    <button
      className={`w-full bg-blue-200 text-white active:bg-emerald-600 font-medium uppercase text-14 px-6 py-3 rounded-sm ${styles}`}
      type={type}
      onClick={accept}
    >
      {text}
    </button>
  );
}

export default BtnModal;
